import React, { useState, useEffect } from "react";
import { createDriverPayout } from "../../api/DriverPayoutApi.js";
import { getAllDrivers } from "../../api/driverApi.js";
import { getAllVehicleClientAssignments } from "../../api/vehicalsManagementApi.js";
import { getAllDriverPaySlabs } from "../../api/DriverPaySlabApi.js";
import CustomSelect from "../shared/CustomSelect";
import { toast } from "../shared/Toast.jsx";


const AddDriverPayoutModal = ({
    close,
    refresh
}) => {


    const [drivers, setDrivers] = useState([]);
    const [slabs, setSlabs] = useState([]);
    const [assignments, setAssignments] = useState([]);
    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState({
        driverId: "",
        fromDate: "",
        toDate: "",
        totalTrips: "",
        totalAmount: "",
        fuelDeduction: 0,
        penaltyDeduction: 0,
        advanceDeduction: 0,
        otherDeduction: 0,
        status: "Pending",
        remarks: ""
    });

    useEffect(() => {
        fetchDrivers();
        fetchSlabAndAssignments();
    }, []);

    const fetchDrivers = async () => {
        try {
            const response = await getAllDrivers();
            setDrivers(response.data || []);
        }
        catch (error) {
            console.log(error);
        }
    };

    const fetchSlabAndAssignments = async () => {
        try {
            const [slabsRes, assignmentsRes] = await Promise.all([
                getAllDriverPaySlabs(),
                getAllVehicleClientAssignments()
            ]);
            if (slabsRes.success) setSlabs(slabsRes.data || []);
            if (assignmentsRes.success) setAssignments(assignmentsRes.data || []);
        } catch (error) {
            console.error("Failed to load slabs or assignments for auto calculation", error);
        }
    };



    const handleChange = (e) => {
        const { name, value } = e.target;
        let newForm = {
            ...form,
            [name]: value
        };

        if (name === "driverId" || name === "totalTrips") {
            const driverId = name === "driverId" ? value : form.driverId;
            const totalTrips = name === "totalTrips" ? Number(value) : Number(form.totalTrips);
            
            const driverObj = drivers.find(d => String(d.id) === String(driverId));
            if (driverObj && driverObj.vehicleId) {
                const assignment = assignments.find(a => String(a.vehicleId) === String(driverObj.vehicleId));
                if (assignment) {
                    const clientId = assignment.clientId;
                    const slab = slabs.find(s => String(s.vehicleId) === String(driverObj.vehicleId) && String(s.clientId) === String(clientId));
                    if (slab) {
                        const calculatedAmount = (slab.rate || 0) * (totalTrips || 0);
                        newForm.totalAmount = calculatedAmount;
                    }
                }
            }
        }

        setForm(newForm);
    };



    const totalDeduction =

        Number(form.fuelDeduction || 0)
        +
        Number(form.penaltyDeduction || 0)
        +
        Number(form.advanceDeduction || 0)
        +
        Number(form.otherDeduction || 0);



    const payableAmount =

        Number(form.totalAmount || 0)
        -
        totalDeduction;



    const handleSubmit = async (e) => {


        e.preventDefault();


        try {


            setLoading(true);



            const payload = {


                driverId: form.driverId,


                fromDate: form.fromDate,

                toDate: form.toDate,


                totalTrips: Number(form.totalTrips),


                totalAmount: Number(form.totalAmount),


                fuelDeduction: Number(form.fuelDeduction),

                penaltyDeduction: Number(form.penaltyDeduction),

                advanceDeduction: Number(form.advanceDeduction),

                otherDeduction: Number(form.otherDeduction),


                totalDeduction,


                payableAmount,


                status: form.status,


                remarks: form.remarks


            };



            await createDriverPayout(payload);

            toast.success("Driver payout created successfully");

            refresh();

            close();



        }
        catch (error) {

            console.log(error);

            toast.error("Failed to create payout");

        }
        finally {

            setLoading(false);

        }


    };





    return (

        <div

            style={{

                position: "fixed",

                top: 0,

                left: 0,

                width: "100%",

                height: "100%",

                background: "rgba(0,0,0,0.5)",

                display: "flex",

                justifyContent: "center",

                alignItems: "center",

                zIndex: 1000

            }}

        >


            <form


                onSubmit={handleSubmit}


                style={{

                    background: "#fff",

                    width: 600,

                    maxHeight: "90vh",

                    overflowY: "auto",

                    padding: 30,

                    borderRadius: 12

                }}

            >



                <h2>
                    Add Driver Payout
                </h2>



                <label>
                    Driver
                </label>
                <CustomSelect
                    value={form.driverId}
                    onChange={(val) => {
                        setForm((prev) => ({ ...prev, driverId: val }));
                    }}
                    options={[
                        { value: "", label: "Select Driver" },
                        ...drivers.map((driver) => ({
                            value: driver.id,
                            label: driver.driverName || "Driver",
                        }))
                    ]}
                    placeholder="Select Driver"
                    searchable
                    width="100%"
                />
                <div style={{ marginBottom: "15px" }} />





                <div style={rowStyle}>


                    <div>

                        <label>
                            From Date
                        </label>

                        <input

                            type="date"

                            name="fromDate"

                            value={form.fromDate}

                            onChange={handleChange}

                            style={inputStyle}

                        />

                    </div>



                    <div>

                        <label>
                            To Date
                        </label>


                        <input

                            type="date"

                            name="toDate"

                            value={form.toDate}

                            onChange={handleChange}

                            style={inputStyle}

                        />

                    </div>


                </div>





                <label>
                    Total Trips
                </label>


                <input

                    type="number"

                    name="totalTrips"

                    value={form.totalTrips}

                    onChange={handleChange}

                    style={inputStyle}

                />





                <label>
                    Total Amount
                </label>


                <input

                    type="number"

                    name="totalAmount"

                    value={form.totalAmount}

                    onChange={handleChange}

                    style={inputStyle}

                />





                <h3>
                    Deductions
                </h3>


                <input
                    type="number"
                    placeholder="Fuel Deduction"
                    name="fuelDeduction"
                    value={form.fuelDeduction}
                    onChange={handleChange}
                    style={inputStyle}
                />


                <input
                    type="number"
                    placeholder="Penalty Deduction"
                    name="penaltyDeduction"
                    value={form.penaltyDeduction}
                    onChange={handleChange}
                    style={inputStyle}
                />


                <input
                    type="number"
                    placeholder="Advance Deduction"
                    name="advanceDeduction"
                    value={form.advanceDeduction}
                    onChange={handleChange}
                    style={inputStyle}
                />


                <input
                    type="number"
                    placeholder="Other Deduction"
                    name="otherDeduction"
                    value={form.otherDeduction}
                    onChange={handleChange}
                    style={inputStyle}
                />
                <label>
                    Status
                </label>
                <CustomSelect
                    value={form.status || "Pending"}
                    onChange={(val) => {
                        setForm((prev) => ({ ...prev, status: val }));
                    }}
                    options={[
                        { value: "Pending", label: "Pending" },
                        { value: "Paid", label: "Paid" },
                    ]}
                    width="100%"
                />
                <div style={{ marginBottom: "15px" }} />





                <label>
                    Remarks
                </label>


                <textarea

                    name="remarks"

                    value={form.remarks}

                    onChange={handleChange}

                    style={inputStyle}

                />





                <div

                    style={{

                        display: "flex",

                        justifyContent: "flex-end",

                        gap: 15,

                        marginTop: 20

                    }}

                >


                    <button

                        type="button"

                        onClick={close}

                        style={cancelBtn}

                    >

                        Cancel

                    </button>



                    <button

                        type="submit"

                        disabled={loading}

                        style={saveBtn}

                    >

                        {

                            loading

                                ?
                                "Saving..."

                                :
                                "Save"

                        }

                    </button>


                </div>




            </form>


        </div>

    )

};


const inputStyle = {

    width: "100%",

    padding: "10px 14px",

    margin: "8px 0 15px",

    border: "1px solid #E5E7EB",

    borderRadius: 8,

    fontSize: "14px",

    outline: "none",

    boxSizing: "border-box"

};



const rowStyle = {

    display: "flex",

    gap: 20

};



const saveBtn = {

    background: "#20B967",

    color: "#fff",

    border: "none",

    padding: "12px 25px",

    borderRadius: 6,

    cursor: "pointer"

};



const cancelBtn = {

    background: "#ddd",

    border: "none",

    padding: "12px 25px",

    borderRadius: 6,

    cursor: "pointer"

};



export default AddDriverPayoutModal;